import React from 'react'
import ReactDOM from 'react-dom'
import 'iframe-resizer/js/iframeResizer.contentWindow'
import App from './App'
import TicketsSeller from './components/TicketsSeller'
import ShadowDom from 'react-shadow'
import { Styles } from './layout/StylesBlock'
import * as serviceWorker from './serviceWorker'
import * as kudagoHackFix from './hackfixes/kudagoHackFix'
import './styles/fonts.css'

kudagoHackFix.fixKudaGoLayout()
renderPagesIn('.kudago-tickets-pages')
renderWidgetsIn('.kudago-tickets-widget')

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.register();
serviceWorker.unregister();

function renderPagesIn(elementSelector) {
    const rootForPages = document.querySelector(elementSelector)
    if (rootForPages !== null) ReactDOM.render(<App />, rootForPages)
}

function renderWidgetsIn(elementSelector) {
    const rootsForEmbedding = document.querySelectorAll(elementSelector)
    rootsForEmbedding.forEach((rootForEmbedding) => renderWidget(rootForEmbedding))
}

function renderWidget(rootForEmbedding) {
    ReactDOM.render((
        <ShadowDom.div className="kudago-tickets-widget-block">
                <TicketsSeller 
                    mobile={isLayoutMobile(rootForEmbedding)}
                    onMobile={rootForEmbedding.getAttribute('data-on-mobile')}
                    onDesktop={rootForEmbedding.getAttribute('data-on-desktop')}
                    performanceId={rootForEmbedding.getAttribute('data-performance')}
                    eventId={rootForEmbedding.getAttribute('data-event')} />
                <Styles />
        </ShadowDom.div>
    ), rootForEmbedding)
}

function isLayoutMobile(rootForEmbedding) {
    const mobile = rootForEmbedding.getAttribute('data-mobile')
    if (mobile !== null) return mobile
    else return kudagoHackFix.isLayoutMobile()
}